import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		statisticsRetrieve: build.query<StatisticsRetrieveApiResponse, StatisticsRetrieveApiArg>({
			query: (queryArg) => ({
				url: `/api/statistics/`,
				params: {
					channel_id: queryArg.channelId,
					date_after: queryArg.dateAfter,
					date_before: queryArg.dateBefore,
				},
			}),
		}),
		statisticsChartList: build.query<StatisticsChartListApiResponse, StatisticsChartListApiArg>({
			query: (queryArg) => ({
				url: `/api/statistics/chart/`,
				params: {
					aggregate_by: queryArg.aggregateBy,
					channel_id: queryArg.channelId,
					date_after: queryArg.dateAfter,
					date_before: queryArg.dateBefore,
				},
			}),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type StatisticsRetrieveApiResponse = /** status 200  */ StatisticsRead;
export type StatisticsRetrieveApiArg = {
	channelId?: string[];
	dateAfter?: string;
	dateBefore?: string;
};
export type StatisticsChartListApiResponse = /** status 200  */ StatisticsChartRead[];
export type StatisticsChartListApiArg = {
	/** Aggregation type: `day`, `month` or `year` */
	aggregateBy?: 'day' | 'month' | 'year';
	channelId?: string[];
	dateAfter?: string;
	dateBefore?: string;
};
export type PeriodStats = {
	approved_actions_count: number;
	clicks_count: number;
	earned: string;
	total_actions_count: number;
};
export type PeriodStatsRead = {
	avg_income_per_post: string | null;
	avg_income_per_action: string | null;
	approved_actions_count: number;
	clicks_count: number;
	earned: string;
	total_actions_count: number;
};
export type Metrics = {
	current_period: PeriodStats;
	prev_period: PeriodStats;
};
export type MetricsRead = {
	current_period: PeriodStatsRead;
	prev_period: PeriodStatsRead;
};
export type AggOffer = {
	uuid: string;
	name: string;
};
export type TopOffers = {
	offer: AggOffer;
};
export type TopOffersRead = {
	offer: AggOffer;
	approved_amount: string;
};
export type PublishedPostChannel = {
	name: string;
	subscribers_count?: number;
};
export type PublishedPostChannelRead = {
	uuid: string;
	name: string;
	logo_url: string | null;
	subscribers_count?: number;
};
export type PublishedPostImage = {
	image: string;
};
export type AggPublishedPost = {
	uuid?: string;
	channel: PublishedPostChannel;
	published_at: string;
	content: string;
	views_count?: number;
	likes_count?: number;
	comments_count?: number;
	images: PublishedPostImage[];
};
export type AggPublishedPostRead = {
	uuid?: string;
	channel: PublishedPostChannelRead;
	published_at: string;
	content: string;
	views_count?: number;
	likes_count?: number;
	comments_count?: number;
	images: PublishedPostImage[];
};
export type TopPublishedPosts = {
	published_post: AggPublishedPost;
};
export type TopPublishedPostsRead = {
	published_post: AggPublishedPostRead;
	approved_amount: string;
};
export type Statistics = {
	metrics: Metrics;
	top_offers: TopOffers[];
	top_published_posts: TopPublishedPosts[];
};
export type StatisticsRead = {
	metrics: MetricsRead;
	top_offers: TopOffersRead[];
	top_published_posts: TopPublishedPostsRead[];
};
export type StatisticsChart = {
	date: string;
	clicks_count: number;
	actions_count: number;
	approved_actions_count: number;
};
export type StatisticsChartRead = {
	date: string;
	clicks_count: number;
	actions_count: number;
	approved_actions_count: number;
	amount: string;
	pending_amount: string;
	declined_amount: string;
	approved_amount: string;
};
